












import { Component, Prop, Vue } from 'vue-property-decorator';
import { PermissionType } from '@shared/common/types';
import { User } from '../user';

@Component
export default class UserEditBtn extends Vue {
  public PermissionType = PermissionType;

  public get realEntityId(): string {
    return this.entity ? this.entity.id : this.entityId;
  }

  public get isVisible(): boolean {
    return !this.entity.deletedAt;
  }

  @Prop()
  public entityId!: string;

  @Prop()
  public entity!: User;
}
